import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-neirong_icon2",
  "use": "icon-neirong_icon2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-neirong_icon2\"><defs><style type=\"text/css\"></style></defs><path d=\"M923.52 809.28V896h-832v-86.72h832zM247.04 454.4v86.656H91.52V454.4h155.52z m676.48 0v86.656H402.56V454.4h520.96zM620.288 128v86.72H91.52V128h528.768z m303.232 0v86.72h-209.92V128h209.92z\" fill=\"#333333\" p-id=\"10345\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol